import React, { useEffect, useState } from "react";
import "./FAQ.css";
import BreadCrumbs from "../../../../components/BreadCrumbs/BreadCrumbs";

import telegramIcon from '../../../../assets/images/telegramIcon.svg'

import whiteArrowIcon from '../../../../assets/images/Home/whiteArrow.svg'
import { Link } from "react-router-dom";
import {Helmet} from "react-helmet";


export default function FAQ() {
    const [openIndex, setOpenIndex] = useState(null);

    const [isMobileToogle, setIsMobileToogle] = useState(false)

    useEffect(() => {
        const checkIfMobile = () => {
            setIsMobileToogle(window.innerWidth <= 500);
        } 

        checkIfMobile();
        window.addEventListener('resize', checkIfMobile);
        
        return () => window.removeEventListener('resize', checkIfMobile);
    }, [])

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const faqSections = [
        {
            title: "General Questions",
            items: [
                {
                    q: "What is an IBC (International Business Company)?",
                    a: "An IBC is a legal entity commonly used for holding, trading, asset protection, and tax planning. It offers 0% tax in many jurisdictions and is fully owned by foreign investors.",
                },
                {
                    q: "Which jurisdictions are best for offshore company formation?",
                    a: (
                        <div>
                            <p><strong>Cost-efficient, 0% tax:</strong> Western Sahara, Mwali, Anjouan, Seychelles, St. Lucia</p>
                            <p><strong>Tier-1, regulatory credibility:</strong> Cyprus, Malta, Mauritius, Gibraltar, Isle of Man, Singapore</p>
                            <p><strong>Strong business hubs:</strong> UAE, Panama — banking access and residency</p>
                        </div>
                    ),
                },
                {
                    q: "How long does it take to register a company?",
                    a: (
                        <div>
                            <p><strong>Fast IBCs:</strong> Western Sahara, St. Lucia, Seychelles — 2–5 days</p>
                            <p><strong>Regulated companies:</strong> Cyprus, Malta, Mauritius — 2–6 weeks</p>
                            <p><strong>Residency-linked setups:</strong> UAE, Indonesia — 2–8 weeks</p>
                        </div>
                    ),
                },
            ],
        },
        {
            title: "Licensing Questions",
            items: [
                {
                    q: "What licenses can Offshore Advisory help with?",
                    a: (
                        <div>
                            <p><strong>Gaming Licenses:</strong> Western Sahara, Mwali, Anjouan, Malta, Cyprus, Curacao, Isle of Man</p>
                            <p><strong>Brokerage & Forex:</strong> Cyprus, Seychelles, St. Vincent, Mwali, Mauritius</p>
                            <p><strong>Banking Licenses:</strong> Western Sahara, Panama, Mauritius, Malta, Isle of Man</p>
                            <p><strong>Crypto & Blockchain:</strong> Malta, Cyprus CASP, Seychelles, Western Sahara</p>
                            <p><strong>Insurance & Trusts:</strong> Anjouan, Mwali, Malta, Cyprus, Isle of Man</p>
                            <p><strong>Asset Management & Funds:</strong> Malta, Cyprus, Mauritius, Gibraltar</p>
                            <p><strong>FinTech & Payments (PSP/EMI):</strong> Malta, Cyprus, Gibraltar, UAE</p>
                        </div>
                    ),
                },
                {
                    q: "Do these licenses have capital requirements?",
                    a: (
                        <div>
                            <p><strong>Low/None:</strong> Western Sahara, Mwali, Anjouan, Seychelles</p>
                            <p><strong>Medium:</strong> Cyprus (€125,000–€730,000 for FX brokers)</p>
                            <p><strong>High:</strong> Malta, Mauritius, Isle of Man (€250,000 to €3M+)</p>
                        </div>
                    ),
                },
            ],
        },
        {
            title: "Banking & Finance Questions",
            items: [
                {
                    q: "Can Offshore Advisory help open bank accounts?",
                    a: "Yes — we open corporate and personal bank accounts in 120+ banks worldwide. We also assist with FinTech/EMI accounts for crypto and forex businesses.",
                },
                {
                    q: "Which jurisdictions are best for offshore banking?",
                    a: (
                        <div>
                            <p><strong>Strong offshore hubs:</strong> Panama, Mauritius, Seychelles</p>
                            <p><strong>Tier-1 EU credibility:</strong> Malta, Cyprus, Isle of Man, Gibraltar</p>
                            <p><strong>Global FinTech centers:</strong> UAE, Singapore</p>
                        </div>
                    ),
                },
            ],
        },
        {
            title: "Residency & Citizenship Questions",
            items: [
                {
                    q: "Which residency programs can Offshore Advisory assist with?",
                    a: (
                        <div>
                            <p>🇪🇸 <strong>Spain:</strong> real estate €500,000+</p>
                            <p>🇮🇹 <strong>Italy:</strong> startups, bonds, philanthropy €250,000+</p>
                            <p>🇬🇷 <strong>Greece:</strong> real estate €250,000–€500,000</p>
                            <p>🇦🇪 <strong>UAE:</strong> company, property, Golden Visa AED 2M+</p>
                            <p>🇮🇩 <strong>Indonesia:</strong> via PT PMA company</p>
                            <p>🇨🇾 <strong>Cyprus:</strong> Residency & Non-Dom Regimes</p>
                        </div>
                    ),
                },
            ],
        },
        {
            title: "Compliance & Tax Questions",
            items: [
                {
                    q: "Is using an offshore company legal?",
                    a: "Yes — when structured correctly, offshore companies are fully legal. Offshore Advisory ensures compliance with AML, KYC, and tax regulations.",
                },
                {
                    q: "Which jurisdictions have 0% tax?",
                    a: "Western Sahara, Mwali, Anjouan, St. Lucia, St. Vincent, Seychelles, UAE Free Zones, Isle of Man.",
                },
            ],
        },
        {
            title: "Offshore Advisory Support",
            items: [
                {
                    q: "Why should I choose Offshore Advisory?",
                    a: (
                        <div>
                            <p>20+ jurisdictions covered</p>
                            <p>⚡ Fast incorporation & licensing</p>
                            <p>Compliance-first approach</p>
                            <p>One-stop setup: company + license + bank + residency</p>
                        </div>
                    ),
                },
                {
                    q: "How do I get started?",
                    a: "Simply book a free consultation and our experts will create a tailored plan for your business or residency needs.",
                },
            ],
        },
    ];

    return (
        <main className='main'>

            <Helmet>
                <title>Offshore FAQs | Licensing, Company Formation & Residency</title>
                <meta name="description" content="Get answers on offshore licensing, company formation, residency programs, costs, compliance, and timelines for global business setup." />
                <meta name="keywords" content="
                    offshore FAQs, company formation questions, offshore licensing guide, residency by investment FAQ, global business setup, offshore compliance, business registration abroad, international tax questions
                "
                />
            </Helmet>

            <section className='section'>
               {!isMobileToogle ? (
                    <BreadCrumbs
                        data={[
                            {
                                name: 'Offshore Advisory',
                                link: '/',
                            },
                            {
                                name: 'FAQ',
                                link: '/faq',
                            },
                        ]}
                    />
                ) : null}
                
                <div className="faq-container container">
                    <div className="faq-content">
                        <div className="faq-header">
                            <div className="faq-badge">
                                <BreadCrumbs
                                    data={[
                                        {
                                            name: 'Offshore Advisory',
                                            link: '/',
                                        },
                                        {
                                            name: 'FAQ',
                                            link: '/faq',
                                        },
                                    ]}
                                />  
                                </div>
                            <h1 className="faq-title">Frequently Asked Questions</h1>
                            <p className="faq-subtitle">
                                Everything You Need to Know About Offshore Licensing, Company Formation & Residency
                            </p>
                            <p className="faq-description">
                                We understand that clients have many questions about jurisdictions, compliance, timelines, and costs.
                                Here are the most common answers to help you make confident, informed decisions.
                            </p>
                            <Link to='/newsletter' className="btn-shareit">
                                Share it
                                <img src={telegramIcon} alt="Telegram" />
                            </Link>
                        </div>

                        {faqSections.map((section, sIdx) => (
                            <div key={sIdx} className="faq-section">
                                <h2 className="faq-section-title">{section.title}</h2>
                                <div className="faq-list">
                                    {section.items.map((item, iIdx) => {
                                        const globalIndex = `${sIdx}-${iIdx}`;
                                        const isOpen = openIndex === globalIndex;

                                        return (
                                            <div key={iIdx} className="faq-item">
                                                <button
                                                    className={`faq-question ${isOpen ? "open" : ""}`}
                                                    onClick={() => toggleFAQ(globalIndex)}
                                                >
                                                    <span className="faq-question-text">{item.q}</span>
                                                    <span className={`faq-icon ${isOpen ? "open" : ""}`}>
                                                        {isOpen ? "−" : "+"}
                                                    </span>
                                               </button>
                                                {isOpen && (
                                                    <div className="faq-answer">
                                                        {typeof item.a === "string" ? <p>{item.a}</p> : item.a}
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        ))}
                        
                       
                    </div>
                </div>
                        <div className="still-question-background">
                            <div className="still-question-content">
                                <h2 className="still-question-title">
                                    Still have questions?
                                </h2>
                                <p className="still-question-descr">
                                    Our team is here to help
                                </p>
                                <Link to='/newsletter' className="still-question-btn">
                                    Contact Us Today
                                    <img src={whiteArrowIcon} alt="" />
                                </Link>
                            </div>
                        </div>
            </section>
            {/* <Footer /> */}
        </main>
    );
}
